/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type SbRespMainContent_itemSearch = {
    readonly topCategoryL1: VerticalType | null;
    readonly displayUriRef: string | null;
    readonly pageType: string | null;
    readonly displayMaxNumberOfPages: number | null;
    readonly bottomModule: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"SharedBottomModule_bottomModule">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuSelector_itemSearch" | "SbRespSortItems_itemSearch" | "SbRespPageSize_itemSearch" | "SbRespBrowseHeader_itemSearch" | "SbRespSearchResultContainer_itemSearch" | "SbSharedRelatedItems_itemSearch" | "SbRespRefineTopNav_itemSearch" | "SbSharedRecentlySoldItems_itemSearch" | "SbRespAppliedFilters_itemSearch">;
    readonly " $refType": "SbRespMainContent_itemSearch";
};
export type SbRespMainContent_itemSearch$data = SbRespMainContent_itemSearch;
export type SbRespMainContent_itemSearch$key = {
    readonly " $data"?: SbRespMainContent_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespMainContent_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespMainContent_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topCategoryL1",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUriRef",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayMaxNumberOfPages",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BottomModule",
      "kind": "LinkedField",
      "name": "bottomModule",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedBottomModule_bottomModule"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuSelector_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespSortItems_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespPageSize_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespBrowseHeader_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespSearchResultContainer_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedItems_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopNav_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRecentlySoldItems_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespAppliedFilters_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'ca6450ef15701f93394b0a0b06b9a856';
export default node;
